import { IconAlertTriangle, IconHelpCircle } from "@tabler/icons-react";
import * as React from "react";

import { cn } from "@beweegbaas/ui/lib/utils";
import { Button, type ButtonProps } from "./button";
import { Popover, PopoverContent, PopoverTrigger, type Side } from "./popover";

export interface InfoPopoverProps {
  children: React.ReactNode;
  variant?: "help" | "warning";
  side?: Side;
  align?: "start" | "center" | "end";
  sideOffset?: number;
  className?: string;
  triggerClassName?: string;
  iconClassName?: string;
  buttonProps?: ButtonProps;
}

export function InfoPopover({
  children,
  variant = "help",
  side = "top",
  align = "center",
  sideOffset = 4,
  className,
  triggerClassName,
  iconClassName = "size-4",
  buttonProps,
}: InfoPopoverProps) {
  const Icon = variant === "warning" ? IconAlertTriangle : IconHelpCircle;
  const buttonLabel = variant === "warning" ? "Warning" : "More information";

  return (
    <Popover>
      <PopoverTrigger
        render={
          <Button
            size="icon-xs"
            variant="ghost"
            className={cn(
              variant === "warning"
                ? "text-amber-500 hover:text-amber-600"
                : "text-muted-foreground hover:text-foreground",
              triggerClassName,
            )}
            nativeButton={true}
            aria-label={buttonLabel}
            title={buttonLabel}
            {...buttonProps}
          >
            <span className="sr-only">{buttonLabel}</span>
            <span aria-hidden>
              <Icon className={iconClassName} />
            </span>
          </Button>
        }
      />
      <PopoverContent
        side={side}
        align={align}
        sideOffset={sideOffset}
        className={cn("w-72", className)}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
